import styled from 'styled-components'
import theme from '../../styles/theme';

const StPosts = styled.div`

`

export {StPosts}